<section class="my-news" *ngIf="banners.data && banners.data.length > 0">
  <div [ngClass]="{ container: !adminMode }">
    <div class="header">
      <div class="header__title" *ngIf="title">News</div>
    </div>
    <section class="grid grid-{{ grid }}">
      <ng-container *ngFor="let i of banners.data; let index = index">
        <div class="my-card">
          <img loading="lazy"
            src="{{ imgUrl + i.image }}"
            alt="..."
            (error)="commonService.handleError($event)"
            [routerLink]="'/news/' + i.slug"
          />
          <div class="my-card__body">
            <div class="my-card__body--meta">{{ i.category }}</div>
            <h4 class="my-card__body--title" [routerLink]="'/news/' + i.slug">
              {{ i.title }}
            </h4>
            <div class="my-card__body--details">
              <div class="item">
                <i class="fa fa-clock"></i>
                <span>{{ bottomBanner.convertDate(i.created) }}</span>
              </div>
              <div class="item">
                <i class="fa fa-user"></i>
                <span>
                  {{ i.author }}
                </span>
              </div>
              <div
                class="item"
                style="color: salmon !important"
                *ngIf="isMarketplace"
              >
                <i class="fa fa-heart"></i>
                <span>{{ i.bottomBannerLikes?.length }}</span>
              </div>
            </div>
            <div class="text-right mr-3">
              <button *ngIf="adminMode" (click)="assign(i)">Assign</button>
            </div>
          </div>
        </div>
      </ng-container>
    </section>
    <br />
    <div class="d-flex justify-content-end">
      <nav aria-label="..." class="mb-3" *ngIf="banners.lastPage > 1">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="banners.currentPage === 1">
            <button class="page-link" (click)="get_bottom_banner()">
              First
            </button>
          </li>
          <ng-container *ngFor="let page of totalPage">
            <li class="page-item" [class.active]="page === banners.currentPage">
              <button class="page-link" (click)="get_bottom_banner(page)">
                {{ page }}
              </button>
            </li>
          </ng-container>
          <li
            class="page-item"
            [class.disabled]="banners.currentPage === banners.lastPage"
          >
            <button
              class="page-link"
              (click)="get_bottom_banner(banners.lastPage)"
            >
              Last
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</section>

<app-marketplace-bottom-banner
  #marketplaceBottomBanner
  [showBody]="false"
></app-marketplace-bottom-banner>

<ng-template #AssignOption let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign Article</h4>
    <a (click)="modal.dismiss('Cross click')"
      ><i class="fa fa-window-close" aria-hidden="true"></i
    ></a>
  </div>
  <div class="modal-body">
    <section>
      <div>Category :</div>
      <div class="my-4 row d-flex justify-content-center">
        <ng-container *ngFor="let c of categoriesList">
          <span class="sub-cate p-2 m-2">
            <input type="checkbox" [(ngModel)]="c.checked" /> {{ c.name }}</span
          >
        </ng-container>
      </div>
    </section>

    <section>
      <div>Sub Region :</div>
      <div class="my-4 row d-flex justify-content-center">
        <ng-container *ngFor="let s of subRegionList">
          <span class="sub-cate p-2 m-2">
            <input type="checkbox" [(ngModel)]="s.checked" /> {{ s.name }}</span
          >
        </ng-container>
      </div>
    </section>

    <duv class="d-flex justify-content-end">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="assignArticles()"
      >
        Assign
      </button>
    </duv>
  </div>
</ng-template>
